/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $filter,
  $mdUtil,
  webpage,
  eventService,
  uiService,
  actionService,
  navigationService,
  organizationService,
  accountsService,
  OrganizationDetails,
  OrganizationIntegrations,
  ACCOUNT
) => {
  $scope.Model = {
    availablePhones: [],
    availableAccounts: [],
    phonesList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  if ($rootScope.CurrentAccount.isAdministrator) {
    webpage.pageTitle('Loading, please wait');

    organizationService
      .readOrganization({ id: $rootScope.CurrentOrganization.id })
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.organization = OrganizationDetails.build(
          data.organization
        );
        $rootScope.CurrentOrganization.integrations = OrganizationIntegrations.build(
          data.integrations
        );
      })
      .then(() => {
        if ($rootScope.CurrentOrganization.hasComms()) {
          return $q
            .all([
              organizationService.phoneList({
                id: $rootScope.CurrentOrganization.integrations.comms.authId
              }),
              accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST })
            ])
            .then((data) => {
              $scope.Model.availablePhones = data[0]?.objects || [];
              $scope.Model.availableAccounts = data[1] || [];

              if ($scope.Model.availablePhones?.length) {
                let len = $scope.Model.availablePhones.length;
                while (len--) {
                  $scope.Model.availablePhones[len].id =
                    $scope.Model.availablePhones[len].number;
                  $scope.Model.availablePhones[len].owners = [];
                  const assignedPhone = _.find(
                    $rootScope.CurrentOrganization.integrations.comms.phones,
                    (p) => p.number === $scope.Model.availablePhones[len].number
                  );
                  if (assignedPhone && assignedPhone.idOwner) {
                    $scope.Model.availablePhones[len].owners = _.filter(
                      $scope.Model.availableAccounts,
                      (a) => assignedPhone.idOwner.indexOf(a.id) > -1
                    );
                  }
                }
                $rootScope.CurrentOrganization.integrations.comms.phones = _.filter(
                  $rootScope.CurrentOrganization.integrations.comms.phones,
                  (p) => _.find($scope.Model.availablePhones, (ap) => ap.number === p.number)
                );
              }
            });
        }
        return true;
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Connect : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Event Listeners
   * --------------------------------------------------------------------------------
   */
  $scope.$on('phoneRent', ($event) => {
    eventService.phoneRent({ event: $event });
  });
  $scope.$on('phoneUnrent', () => {
    actionService.deleteDocuments(
      $scope.Model.phonesList.getSelected(),
      $scope.phoneUnrent,
      $scope.Model.phonesList.removeData,
      'phone(s)',
      'unrented'
    );
  });

  /*
   * List Events
   * --------------------------------------------------------------------------------
   */
  $scope.phoneAssign = ($event, phone) => {
    eventService.phoneAssign({
      event: $event,
      phone: phone,
      accounts: $scope.Model.availableAccounts
    });
  };
  $scope.phoneAssigned = (phone) => {
    if (
      $rootScope.CurrentOrganization.integrations.comms.phones &&
      $rootScope.CurrentOrganization.integrations.comms.phones.length
    ) {
      let len = $rootScope.CurrentOrganization.integrations.comms.phones.length;
      while (len--) {
        if (
          $rootScope.CurrentOrganization.integrations.comms.phones[len].number === phone.number
        ) {
          $rootScope.CurrentOrganization.integrations.comms.phones[len].idOwner = _.map(
            phone.owners,
            'id'
          );
        }
      }
    } else {
      try {
        $rootScope.CurrentOrganization.integrations.comms.phones = [];
        $rootScope.CurrentOrganization.integrations.comms.phones.push({
          number: phone.number,
          idOwner: _.map(phone.owners, 'id')
        });
      } catch (e) {
        //
      }
    }
    organizationService
      .updateOrganization({
        id: $rootScope.CurrentOrganization.id,
        integrations: {
          comms: {
            phones: $rootScope.CurrentOrganization.integrations.comms.phones
          }
        },
        organization: { shorthand: $rootScope.CurrentOrganization.organization.shorthand }
      })
      .then((result) => {
        if (result.status) {
          $scope.Model.phonesList.setDataReplace(phone, 'number');
          navigationService.organizationChange({
            idOrganization: $rootScope.CurrentOrganization.id
          });
          uiService.toast({
            text: {
              p1: 'Phone',
              p2: phone.number.formatAsPhone(),
              p3: 'has been updated'
            }
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Something',
              p2: 'went wrong',
              p3: 'please try again'
            },
            warn: true
          });
        }
      });
  };
  $scope.phoneRented = (phone) => {
    if (phone) {
      delete phone.isSelected;
      phone.idOwner = [$rootScope.CurrentAccount.id];
      phone.owners = [
        _.find($scope.Model.availableAccounts, (a) => a.id === $rootScope.CurrentAccount.id)
      ];
      phone.added_on = moment.utc().tz($rootScope.CurrentTimeZone()).format('YYYY-MM-DD');
      organizationService.phoneRent({ phoneNumber: phone.number }).then((result) => {
        if (result.status) {
          $rootScope.CurrentOrganization.integrations.comms.phones.push(phone);
          $scope.Model.phonesList.setDataAppend(phone);
          uiService.toast({
            text: {
              p1: 'Phone',
              p2: phone.number.formatAsPhone(),
              p3: 'has been rented'
            }
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Something',
              p2: 'went wrong',
              p3: 'please try again'
            },
            warn: true
          });
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Something',
          p2: 'went wrong',
          p3: 'please try again'
        },
        warn: true
      });
    }
  };
  $scope.phoneUnrent = (phoneNumber) => {
    return organizationService.phoneUnrent({ phoneNumber: phoneNumber.id });
  };
  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected
      ? isSelected
      : list.isSelectedAny();
  };
  $scope.listReady = (list) => {
    $scope.Model.phonesList = list;
    $scope.Model.phonesList.setOrderBy('number');
  };

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  $scope.toggleConnect = () => {
    organizationService
      .phoneEnable()
      .then(() => {
        $scope.saveOrganization();
      })
      .catch(() => {
        $scope.saveOrganization();
      });
  };
  $scope.saveOrganization = $mdUtil.debounce(() => {
    organizationService
      .updateOrganization({
        id: $rootScope.CurrentOrganization.id,
        integrations: {
          comms: {
            useSms: $rootScope.CurrentOrganization.integrations.comms.useSms,
            usePhone: $rootScope.CurrentOrganization.integrations.comms.usePhone
          }
        },
        organization: { shorthand: $rootScope.CurrentOrganization.organization.shorthand }
      })
      .then((result) => {
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Connect details',
              p2: 'saved',
              p3: 'successfully'
            }
          });
        }
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
      });
  }, 1500);
};
